import { render, staticRenderFns } from "./BlockCardImageGrid.vue?vue&type=template&id=665db4c4&scoped=true&"
import script from "./BlockCardImageGrid.vue?vue&type=script&lang=ts&"
export * from "./BlockCardImageGrid.vue?vue&type=script&lang=ts&"
import style0 from "./BlockCardImageGrid.vue?vue&type=style&index=0&id=665db4c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665db4c4",
  null
  
)

export default component.exports